import * as React from 'react';
import {useTranslation} from 'react-i18next';
import styles from './BackButton.scss';
import {IOuter} from './BackButton.types';
import BackButtonIcon from './BackButtonIcon.svg';

export const BackButton: React.FunctionComponent<IOuter> = ({onClick}) => {
  const {t} = useTranslation();

  return (
    <button
      className={styles.backButton}
      aria-label={t('mgw.backButton')}
      data-hook="back-button-global"
      onClick={onClick}
    >
      <BackButtonIcon />
    </button>
  );
};

BackButton.displayName = 'BackButton';
